import type { ReactNode } from 'react';
import { PleriPageLoader } from '@plerionhq/design-system/experimental';
import {
  isClientFeatureEnabled,
  PLERI_PAGE_LOADER_FLAG,
} from './client-feature-flags';

export function PageLoadingFallback({
  legacy = 'Loading...',
}: {
  legacy?: ReactNode;
}) {
  return isClientFeatureEnabled(PLERI_PAGE_LOADER_FLAG) ? (
    <PleriPageLoader />
  ) : (
    <>{legacy}</>
  );
}
